import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { EquipmentType } from '@core/interfaces';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';
import { debounceTime } from 'rxjs/operators';

import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EquipmentsTypeSelectComponent),
  multi: true
};

@Component({
  selector: 'equipments-type-select',
  templateUrl: './equipments-type-select.component.html',
  styleUrls: ['./equipments-type-select.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class EquipmentsTypeSelectComponent implements ControlValueAccessor, OnInit  {
  @Input() required = true;
  @Input() disabled = false;
  @Input() appearance = 'legacy';

  equipmentsTypes: EquipmentType[];
  selectedValue: FormControl = new FormControl();

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private equipmentsTypesApi: EquipmentsTypesApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });

    this.searchEquipmentsTypes();
    this.selectedValue.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      if (value) {
        this.onChange(value);
      }
    });
  }

  ngOnInit(): void {
    if (this.required) {
      this.selectedValue.setValidators(Validators.required);
    }
  }

  searchEquipmentsTypes(): void {
    const options = {
      where: { archived: false },
      orderBy: 'name_asc',
      limit: 100,
      offset: 0
    };

    this.equipmentsTypesApi
    .listEquipmentsTypes(options)
    .subscribe((response) => {
      this.equipmentsTypes = response.items;

        if (this.selectedValue.value) {
          const currentEquipmentTypeIsOnList = this.equipmentsTypes.some((equipmentType) => {
            return equipmentType.id === this.selectedValue.value.id;
          });

          if (!currentEquipmentTypeIsOnList) {
            this.equipmentsTypes.push(this.selectedValue.value);
          }
        }
      });
  }

  compareEquipmentType(someEquipmentType: EquipmentType, anotherEquipmentType: EquipmentType): boolean {
    return (someEquipmentType && anotherEquipmentType)
    && (someEquipmentType.id === anotherEquipmentType.id);
  }

  writeValue(equipmentType: EquipmentType): void {
    this.selectedValue.setValue(equipmentType);
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
